// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"21b96c40","530":"ce5b72da","617":"07699d63","855":"bea29d71","926":"e0f6c30f"}[chunkId] + ".css";
};